import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import PromoTemplateApp from 'bundles/promo-template/components/PromoTemplateApp';

const DevDomain = loadOnRoute(() => import('bundles/promo-template/pages/DevDomain'));
const ExploreDomain = loadOnRoute(() => import('bundles/promo-template/pages/consumer/ExploreDomain'));
const EnterpriseExploreDomain = loadOnRoute(
  () => import('bundles/promo-template/pages/enterprise/EnterpriseExploreDomain')
);
const EmbeddedPages = loadOnRoute(() => import('bundles/promo-template/pages/EmbeddedPages'));

export default (
  <Route>
    <Route path="/" component={PromoTemplateApp}>
      {/* This is a demo page that lists the embedded promo-template pages that are embedded in other apps */}
      <Route path="promo-template/embedded-pages" getComponent={EmbeddedPages} />
      {/* promoTemplate-testPage is a sample slug */}
      <Route path="promo-template/:pageSlug" getComponent={DevDomain} />
      {['explore/:pageSlug', '/google-career-certificates'].map((path) => (
        <CourseraRoute
          key={path}
          handle={{
            tracking: {
              data: () => ({
                page: { type: 'promo_template', segment: 'consumer' },
              }),
            },
          }}
          path={path}
          getComponent={ExploreDomain}
        />
      ))}
      <CourseraRoute
        handle={{
          tracking: {
            data: (params) => ({
              page: { type: 'promo_template', segment: 'enterprise' },
              enterprise: {
                ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
              },
            }),
          },
        }}
        path="programs/:programSlug/explore/:pageSlug"
        getComponent={EnterpriseExploreDomain}
      />
    </Route>
    <Route path="*" component={NotFound} />
  </Route>
);
